import { Image } from '@chakra-ui/react';
import React from 'react';
import footerLogo from '@/assets/forsport/images/logo-brand.svg';

export default function index() {
  return <Image src={footerLogo} maxW="92px" ml={['0', null, '4']} />;
}
